app.directive('errors', function() {
  return {
    restrict: 'E',
    templateUrl: 'directives/errors.html',
  };
});